import { Component, OnInit, Input } from '@angular/core';
import { Label, MultiDataSet } from 'ng2-charts';
import { ChartType } from 'chart.js';
import { RecordsService } from '../services/records.service';
import { TranslateService } from '@ngx-translate/core';
import * as CanvasJS from '../../assets/canvasjs.min';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-chartedition',
  templateUrl: './chartedition.component.html',
  styleUrls: ['./chartedition.component.css']
})
export class CharteditionComponent implements OnInit {

  public link: string = 'http://trad.fondation.org.ma:8090/api/editeurs';
  public chart: any;
  public name: string = "Editeurs";
  public namep: string = "Editeurs";
  public total: number = 0;
  public bdr: number = 0;
  public def: number = 0;
  
  @Input() set linkv(val: string) {
    this.link = val;
    this.chargeedit();
  }
  
  @Input() set lcount(val: string) {
    //console.log(val);
    this.bdr = parseInt(val);
    
  }
  @Input() set namec(val: string) {
    this.name = val;
  }
  @Input() set namecol(val: string) {
    this.namep = val;
  }
  
  public editeurs: any;
  
  constructor(private recordservice: RecordsService, public translate: TranslateService,private httpClient: HttpClient) { }

  ngOnInit(): void {
    this.chart = "";
    //console.log(this.link);
    this.translate.onLangChange.subscribe(() => {
      this.chargeedit();
    });
  }

  public chargeedit() {
    
    if(this.bdr==0) this.bdr = this.recordservice.nbtout;

    this.total = 0;
    this.recordservice.getFilters(this.link)
      .subscribe(datan => {
        this.editeurs = datan;
        for (let index = 0; index < this.editeurs.length; index++) {
            this.total += parseInt(this.editeurs[index]['y']);
        }
        this.def = this.bdr - this.total;
        if(this.def>0) {
          if(this.namep == 'traducteurs' || this.namep == 'auteurs') { this.editeurs.push({name: 'Autres -- أخرى', y: this.def }); }
          else { this.editeurs.push({name: 'Autres - أخرى', y: this.def }); }
        }
        this.chart = new CanvasJS.Chart(this.name, {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,
          title:{
            text: this.name
          },
          data: [{
            type: "pie",
            showInLegend: true,
            toolTipContent: "<b>{name}</b>: {y}\n - (#percent%)",
            indexLabel: "(#percent%) - {y} : {name}",
            dataPoints: this.editeurs
          }]
        });
          
        this.chart.render();
      }, err =>{
        console.log(err);
      });
  }

  // chartClicked(e: any){
  //   console.log(e);
  // }

}
